import { Link } from "react-router-dom";
import { PageHead } from "@/components/PageHead";
import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/site";

export default function Faq() {
  return (
    <div data-testid="faq-page">
      <PageHead eyebrow={FAQ.eyebrow} titleLines={[FAQ.title]} intro={FAQ.intro} />
      <section className="edge pb-24 md:pb-32" data-testid="faq-content">
        <div className="mx-auto max-w-3xl">
          {FAQ.groups.map((g, gi) => (
            <Reveal key={g.group} className="mb-16 last:mb-0">
              <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
                <div className="md:col-span-4">
                  <span className="eyebrow">{String(gi + 1).padStart(2, "0")}</span>
                  <h2 className="mt-3 text-xl font-light tracking-editorial md:text-2xl">
                    {g.group}
                  </h2>
                </div>
                <div className="md:col-span-8">
                  <Accordion type="single" collapsible className="w-full" data-testid={`faq-group-${gi}`}>
                    {g.items.map((item, ii) => (
                      <AccordionItem key={ii} value={`${gi}-${ii}`} className="border-b border-border/60">
                        <AccordionTrigger
                          data-testid={`faq-q-${gi}-${ii}`}
                          className="py-5 text-left text-base font-normal tracking-editorial hover:no-underline"
                        >
                          {item.q}
                        </AccordionTrigger>
                        <AccordionContent className="pb-5 text-base leading-relaxed text-muted-foreground">
                          {item.a}
                        </AccordionContent>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-secondary/40" data-testid="faq-cta">
        <div className="edge py-20 text-center md:py-28">
          <h2 className="text-2xl font-light tracking-editorial md:text-3xl">
            Still have a question?
          </h2>
          <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-muted-foreground">
            Our team is happy to help with material selection, samples and project pricing.
          </p>
          <Link
            to="/contact"
            data-testid="faq-contact-cta"
            className="mt-8 inline-block bg-primary px-8 py-4 text-sm uppercase tracking-[0.16em] text-primary-foreground transition-opacity hover:opacity-90"
          >
            Request a Consultation →
          </Link>
        </div>
      </section>
    </div>
  );
}
